import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RequestErrorService {

  fireError: Subject<any> = new Subject<any>();

  constructor() { }
}
